import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Note: If you deploy to Vercel, this should be your production URL.
// Since we set up a proxy in package.json/setupProxy.js, we can just use relative paths locally
const API_URL = '/api/seo';

const DynamicSEO = () => {
  const location = useLocation();

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        let slug = location.pathname;

        // Ignore admin routes
        if (slug.includes("/admin")) return;

        // Normalize slug (e.g. "/" becomes "home")
        slug = slug.replace(/^\/|\/$/g, "") || "home";

        const res = await fetch(`${API_URL}`);
        if (!res.ok) return;
        
        const data = await res.json();
        
        // Find the matched slug from the SEO list
        const seo = data.find(item => item.slug === slug);

        if (seo) {
          const { title, description, keywords, image } = seo;

          // Update title
          if (title) {
            document.title = title;
          }

          // Update description
          if (description) {
            let desc = document.querySelector('meta[name="description"]');
            if (!desc) {
              desc = document.createElement("meta");
              desc.setAttribute("name", "description");
              document.head.appendChild(desc);
            }
            desc.setAttribute("content", description);
          }

          // Update keywords
          if (keywords) {
            let kwds = document.querySelector('meta[name="keywords"]');
            if (!kwds) {
                kwds = document.createElement("meta");
                kwds.setAttribute("name", "keywords");
              document.head.appendChild(kwds);
            }
            kwds.setAttribute("content", keywords);
          }

          // Update OpenGraph title
          let ogTitle = document.querySelector('meta[property="og:title"]');
          if (!ogTitle) {
            ogTitle = document.createElement("meta");
            ogTitle.setAttribute("property", "og:title");
            document.head.appendChild(ogTitle);
          }
          ogTitle.setAttribute("content", title);

          // Update OpenGraph description
          if (description) {
              let ogDesc = document.querySelector('meta[property="og:description"]');
              if (!ogDesc) {
                ogDesc = document.createElement("meta");
                ogDesc.setAttribute("property", "og:description");
                document.head.appendChild(ogDesc);
              }
              ogDesc.setAttribute("content", description);
          }

          // Update Canonical
          let canonical = document.querySelector('link[rel="canonical"]');
          if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
          }
          const url = slug === "home"
              ? "https://sohamdang.vercel.app/"
              : `https://sohamdang.vercel.app/${slug}`;
          canonical.setAttribute("href", url);
        }
      } catch (err) {
        // silently ignore if SEO record not found
        console.error("DynamicSEO Error:", err);
      }
    };

    fetchSEO();
  }, [location.pathname]);

  return null;
};

export default DynamicSEO;
